import Layout from "@/components/Layout";
import { AttendanceDailyPanel } from "@/components/hr/AttendanceDailyPanel";

export default function AttendanceDaily() {
  return (
    <Layout title="Daily attendance">
      <AttendanceDailyPanel />
    </Layout>
  );
}
